import Direction from './direction.js';



const Side = {
    LEFT: 0,
    RIGHT: 1,
    TOP: 2,
    BOTTOM: 3,
};

const SideParams = [];

SideParams[Side.LEFT] = {
    direction: Direction.HORIZONTAL,
    farSide: false,
};

SideParams[Side.RIGHT] = {
    direction: Direction.HORIZONTAL,
    farSide: true,
};

SideParams[Side.TOP] = {
    direction: Direction.VERTICAL,
    farSide: false,
};

SideParams[Side.BOTTOM] = {
    direction: Direction.VERTICAL,
    farSide: true,
};



export default Side;
export { Side, SideParams };
